export default function formatInterval (stageInterval) {
  if (stageInterval === null) {
    return 'не опр.'
  }
  let dateParts = []
  if (stageInterval.years > 0) {
    dateParts.push(stageInterval.years + ' г.')
  }
  if (stageInterval.months > 0) {
    dateParts.push(stageInterval.months + ' м.')
  }
  if (stageInterval.days > 0) {
    dateParts.push(stageInterval.days + ' д.')
  }
  if (stageInterval.hours > 0) {
    dateParts.push(stageInterval.hours + ' ч.')
  }
  if (stageInterval.minutes > 0) {
    dateParts.push(stageInterval.minutes + ' м.')
  }
  if (stageInterval.seconds > 0) {
    dateParts.push(stageInterval.seconds + ' с.')
  }
  return dateParts.join(' ')
}



// WEBPACK FOOTER //
// ./src/helpers/formatInterval.js